module.exports = "./img/351a255efb6b3f9758635cf94072b108.jpg";